/**
 * Created by DynamicDog on 2017-02-20.
 */

import {Component} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
@Component({
    selector: 'upload-view',
    template: `
            <bidrag-panel></bidrag-panel>
            <priser-panel></priser-panel>
            <regler-panel></regler-panel>
        `,
})

export class UploadViewComponent {
    constructor(private etikettService:EtikettService) {

    }

    private onUpload() {
    }
}


// WEBPACK FOOTER //
// ./app/upload/upload.view.ts